/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-18 13:56:13
 * @LastEditTime: 2020-08-18 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/endpoint.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getEndpointData,
  createEndpoint,
  editEndpoint,
  getEndpointInfo,
  deleteEndpoint
} from "@/service/endpointService";
const endpoint = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取endpoint列表
     */
    getEndpointData(store, info) {
      return new Promise((resolve, reject) => {
        getEndpointData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建endpoint
     * @param {*} store
     * @param {*} data
     */
    createEndpoint(store, data) {
      return new Promise((resolve, reject) => {
        createEndpoint(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取endpoint详情
     * @param {*} store
     * @param {*} id
     */
    getEndpointInfo(store, id) {
      return new Promise((resolve, reject) => {
        getEndpointInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑endpoint
     * @param {*} store
     * @param {*} data
     */
    editEndpoint(store, data) {
      return new Promise((resolve, reject) => {
        editEndpoint(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除endpoint
     * @param {*} store
     * @param {*} id
     */
    deleteEndpoint(store, id) {
      return new Promise((resolve, reject) => {
        deleteEndpoint(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default endpoint;



// WEBPACK FOOTER //
// ./src/store/modules/endpoint.js